<!-- for gift -->
   function clearActive9() {
     const tabs1 = document.querySelectorAll('.tablinks-gift');
        tabs1.forEach(tab1 => {
          tab1.classList.remove('pcc-active-gift');
        });
      }

     function showMom() {
        clearActive9();
        document.querySelector('.mom-dsk').classList.add('pcc-active-gift');
        document.getElementById("HeaderMenu-collections-online-gift").style.display = "block";
        document.getElementById("HeaderMenu-collections-bridal-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-lites-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-mugdhaa-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-eterknight-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-little-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-rihi-gift").style.display = "none";
      }

      function showDad() {
        clearActive9();
        document.querySelector('.dad-dsk').classList.add('pcc-active-gift');
        document.getElementById("HeaderMenu-collections-online-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-bridal-gift").style.display = "block";
        document.getElementById("HeaderMenu-collections-lites-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-mugdhaa-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-eterknight-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-little-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-rihi-gift").style.display = "none";
      }

      function showKids() {
        clearActive9();
        document.querySelector('.kids-dsk').classList.add('pcc-active-gift');
        document.getElementById("HeaderMenu-collections-online-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-bridal-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-lites-gift").style.display = "block";
        document.getElementById("HeaderMenu-collections-mugdhaa-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-eterknight-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-little-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-rihi-gift").style.display = "none";
      }

      function showHim() {
        clearActive9();
        document.querySelector('.him-dsk').classList.add('pcc-active-gift');
        document.getElementById("HeaderMenu-collections-online-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-bridal-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-lites-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-mugdhaa-gift").style.display = "block";
        document.getElementById("HeaderMenu-collections-eterknight-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-little-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-rihi-gift").style.display = "none";
      }

     function showHer() {
        clearActive9();
        document.querySelector('.her-dsk').classList.add('pcc-active-gift');
        document.getElementById("HeaderMenu-collections-online-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-bridal-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-lites-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-mugdhaa-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-eterknight-gift").style.display = "block";
        document.getElementById("HeaderMenu-collections-little-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-rihi-gift").style.display = "none";
      }
     function showBday() {
        clearActive9();
        document.querySelector('.bir-dsk').classList.add('pcc-active-gift');
        document.getElementById("HeaderMenu-collections-online-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-bridal-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-lites-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-mugdhaa-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-eterknight-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-little-gift").style.display = "block";
        document.getElementById("HeaderMenu-collections-rihi-gift").style.display = "none";
      }
     function showAnniversary() {
        clearActive9();
        document.querySelector('.anni-dsk').classList.add('pcc-active-gift');
        document.getElementById("HeaderMenu-collections-online-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-bridal-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-lites-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-mugdhaa-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-eterknight-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-little-gift").style.display = "none";
        document.getElementById("HeaderMenu-collections-rihi-gift").style.display = "block";
      }


      function gift_color_effect1() {
        showMom();
      }

      function gift_color_effect2() {
        showDad();
      }

      function gift_color_effect3() {
        showKids();
      }

      function gift_color_effect4() {
        showHim();
      }

  function gift_color_effect5() {
    showHer();
      }
  function gift_color_effect6() {
      showBday();
        
      }
  function gift_color_effect7() {
    showAnniversary();
        
      }
 
  window.onload = showMom();


    function clearActive() {
        const tabs = document.querySelectorAll('.tablinks');
        tabs.forEach(tab => {
            tab.classList.remove('pcc-active');
            if (!tab.classList.contains('rihis')) {
                tab.innerHTML = '';
            }
        });
      }
      function showOnline() {
          clearActive();
          document.querySelector('.online').classList.add('pcc-active');
          document.querySelector('.online').innerHTML = 'EXCLUSIVELY ONLINE';
          document.getElementById("HeaderMenu-collections-online").style.display = "block";
          document.getElementById("HeaderMenu-collections-bridal").style.display = "none";
          document.getElementById("HeaderMenu-collections-lites").style.display = "none";
          document.getElementById("HeaderMenu-collections-mugdhaa").style.display = "none";
          document.getElementById("HeaderMenu-collections-eterknight").style.display = "none";
          document.getElementById("HeaderMenu-collections-little").style.display = "none";
          document.getElementById("HeaderMenu-collections-rihi").style.display = "none";
          document.getElementById("HeaderMenu-collections-gcoin").style.display = "none";
        }

        function showBridal() {
          clearActive();
          document.querySelector('.bridal').classList.add('pcc-active');
          document.querySelector('.bridal').innerHTML = 'WEDDING'; 
          document.getElementById("HeaderMenu-collections-online").style.display = "none";
          document.getElementById("HeaderMenu-collections-bridal").style.display = "block";
          document.getElementById("HeaderMenu-collections-lites").style.display = "none";
          document.getElementById("HeaderMenu-collections-mugdhaa").style.display = "none";
          document.getElementById("HeaderMenu-collections-eterknight").style.display = "none";
          document.getElementById("HeaderMenu-collections-little").style.display = "none";
          document.getElementById("HeaderMenu-collections-rihi").style.display = "none";
          document.getElementById("HeaderMenu-collections-gcoin").style.display = "none";
        }

        function showLites() {
          clearActive();
          document.querySelector('.lites').classList.add('pcc-active');
          document.querySelector('.lites').innerHTML = 'PCC LITES';
          document.getElementById("HeaderMenu-collections-online").style.display = "none";
          document.getElementById("HeaderMenu-collections-bridal").style.display = "none";
          document.getElementById("HeaderMenu-collections-lites").style.display = "block";
          document.getElementById("HeaderMenu-collections-mugdhaa").style.display = "none";
          document.getElementById("HeaderMenu-collections-eterknight").style.display = "none";
          document.getElementById("HeaderMenu-collections-little").style.display = "none";
          document.getElementById("HeaderMenu-collections-rihi").style.display = "none";
          document.getElementById("HeaderMenu-collections-gcoin").style.display = "none";
        }

        function showMugdhaa() {
          clearActive();
          document.querySelector('.mugdhaa').classList.add('pcc-active');
          document.querySelector('.mugdhaa').innerHTML = 'MUGDHAA';
          document.getElementById("HeaderMenu-collections-online").style.display = "none";
          document.getElementById("HeaderMenu-collections-bridal").style.display = "none";
          document.getElementById("HeaderMenu-collections-lites").style.display = "none";
          document.getElementById("HeaderMenu-collections-mugdhaa").style.display = "block";
          document.getElementById("HeaderMenu-collections-eterknight").style.display = "none";
          document.getElementById("HeaderMenu-collections-little").style.display = "none";
          document.getElementById("HeaderMenu-collections-rihi").style.display = "none";
          document.getElementById("HeaderMenu-collections-gcoin").style.display = "none";
        }

       function showEterknight() {
          clearActive();
          document.querySelector('.eter').classList.add('pcc-active');
         document.querySelector('.eter').innerHTML = 'ETERKNIGHT';
          document.getElementById("HeaderMenu-collections-online").style.display = "none";
          document.getElementById("HeaderMenu-collections-bridal").style.display = "none";
          document.getElementById("HeaderMenu-collections-lites").style.display = "none";
          document.getElementById("HeaderMenu-collections-mugdhaa").style.display = "none";
          document.getElementById("HeaderMenu-collections-eterknight").style.display = "block";
          document.getElementById("HeaderMenu-collections-little").style.display = "none";
          document.getElementById("HeaderMenu-collections-rihi").style.display = "none";
          document.getElementById("HeaderMenu-collections-gcoin").style.display = "none";
        }
       function showLittle() {
          clearActive();
          document.querySelector('.little').classList.add('pcc-active');
         document.querySelector('.little').innerHTML = 'LITTLE JEWELS';
          document.getElementById("HeaderMenu-collections-online").style.display = "none";
          document.getElementById("HeaderMenu-collections-bridal").style.display = "none";
          document.getElementById("HeaderMenu-collections-lites").style.display = "none";
          document.getElementById("HeaderMenu-collections-mugdhaa").style.display = "none";
          document.getElementById("HeaderMenu-collections-eterknight").style.display = "none";
          document.getElementById("HeaderMenu-collections-little").style.display = "block";
          document.getElementById("HeaderMenu-collections-rihi").style.display = "none";
          document.getElementById("HeaderMenu-collections-gcoin").style.display = "none";
        }
       function showRihi() {
          clearActive();
          document.querySelector('.rihis').classList.add('pcc-active');
          document.getElementById("HeaderMenu-collections-online").style.display = "none";
          document.getElementById("HeaderMenu-collections-bridal").style.display = "none";
          document.getElementById("HeaderMenu-collections-lites").style.display = "none";
          document.getElementById("HeaderMenu-collections-mugdhaa").style.display = "none";
          document.getElementById("HeaderMenu-collections-eterknight").style.display = "none";
          document.getElementById("HeaderMenu-collections-little").style.display = "none";
          document.getElementById("HeaderMenu-collections-rihi").style.display = "block";
          document.getElementById("HeaderMenu-collections-gcoin").style.display = "none";
        }
       function showGcoin() {
          clearActive();
          document.querySelector('.gcb').classList.add('pcc-active');
         document.querySelector('.gcb').innerHTML = 'Astrology and Consultation';
          document.getElementById("HeaderMenu-collections-online").style.display = "none";
          document.getElementById("HeaderMenu-collections-bridal").style.display = "none";
          document.getElementById("HeaderMenu-collections-lites").style.display = "none";
          document.getElementById("HeaderMenu-collections-mugdhaa").style.display = "none";
          document.getElementById("HeaderMenu-collections-eterknight").style.display = "none";
          document.getElementById("HeaderMenu-collections-little").style.display = "none";
          document.getElementById("HeaderMenu-collections-rihi").style.display = "none";
          document.getElementById("HeaderMenu-collections-gcoin").style.display = "block";
        }

      function gold_color_effect1() {
          showOnline();
        }

        function gold_color_effect2() {
          showBridal();
        }

        function gold_color_effect3() {
          showLites();
        }

        function gold_color_effect4() {
          showMugdhaa();
        }

    function gold_color_effect5() {
          showEterknight();
        }
    function gold_color_effect6() {
          showLittle();
        }
    function gold_color_effect7() {
          showRihi();
        }
    function gold_color_effect8() {
          showGcoin();
        }
  window.onload = showOnline();